import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor(private router: Router) {}

  /**
   * Initialize Google Analytics and track page views
   */
  public initialize(): void {
    if (!environment.googleAnalyticsId) {
      console.warn('Google Analytics ID not set in environment');
      return;
    }

    try {
      // Track page views on route changes
      this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe((event) => {
          if (typeof gtag !== 'undefined') {
            gtag('config', environment.googleAnalyticsId, {
              page_path: (event as NavigationEnd).urlAfterRedirects
            });
          }
        });
    } catch (error) {
      console.error('Error initializing Google Analytics', error);
    }
  }

  /**
   * Track custom events
   * @param eventName Name of the event
   * @param eventParams Additional parameters for the event
   */
  public trackEvent(eventName: string, eventParams: any = {}): void {
    if (typeof gtag !== 'undefined' && environment.googleAnalyticsId) {
      gtag('event', eventName, eventParams);
    }
  }

  /**
   * Set user properties
   * @param properties User properties to set
   */
  public setUserProperties(properties: any): void {
    if (typeof gtag !== 'undefined' && environment.googleAnalyticsId) {
      gtag('set', 'user_properties', properties);
    }
  }
}
